import type { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { isNonEmptyString } from '@accesso/cc-std-lib';

import { MerchantStore } from '../../feature/merchant/merchant.store';
import { AuthService } from './auth.service';

export const canDeactivateAuthCallbackGuard: CanDeactivateFn<boolean> = () => {
	const merchantStore = inject(MerchantStore);
	if (!merchantStore.merchant()?.usesProfiles()) return true;

	const profile = inject(AuthService).profile();
	if (!profile?.state().loaded) return true;

	return [profile.personal()?.firstName, profile.personal()?.lastName].every(isNonEmptyString);
};
